// extracted by mini-css-extract-plugin
export var divider = "_3t-0";
export var dividerText = "_3t-1";